import { FC, ReactNode } from "react";
import styles from './CheckboxGroup.module.scss';
import { ErrorMessageIcon } from "../ErrorMessageIcon/ErrorMessageIcon";
import StyledCheckbox from "../StyledCheckbox/StyledCheckbox";

type Props = {
  options: {
    label: string,
    value: string,
    selected: boolean,
  }[],
  onChange: (array: { label: string, value: string, selected: boolean }[]) => void,
  required: boolean,
  errorMessage: string,
  label: string | ReactNode,
  readOnly?: boolean,
}

export const CheckboxGroup: FC<Props> = ({ options, onChange, required, errorMessage, label, readOnly }) => {
  return (
    <div className={styles.container}>
      {label && (
        <span className={styles.label}>
          <span className={styles.innerLabelContainer}>{label} {required && <span className={styles.required}>*</span>}</span>
          {errorMessage && (
            <ErrorMessageIcon
              style={{ whiteSpace: 'nowrap' }}
              errorMessage={errorMessage}
            />
          )}
        </span>
      )}
      {options.map((option) => (
        <label key={option.value} className={styles.option} style={{ cursor: readOnly ? 'not-allowed' : 'pointer' }}>
          <StyledCheckbox
            className={styles.checkbox}
            disabled={readOnly}
            checked={option.selected}
            onChange={() => {
              if (!onChange || readOnly) return;

              const temp = [...options];
              const index = temp.findIndex(x => x.value === option.value);
              temp[index].selected = !temp[index].selected;
              onChange?.(temp);
            }}
          />
          <span>{option.label}</span>
        </label>
      ))}
    </div>
  )
}